import React from 'react';
import { Chip, useIsMobile, useT } from '@repo/common';

/**
 * Refunds & Cancellations 필터. 서버의 filter 파라미터와 1:1.
 * REQUESTED 가 어드민이 실제로 처리해야 하는 줄이다.
 */
export const REFUND_FILTERS = [
  { value: 'ALL', label: 'All', labelKr: '전체' },
  { value: 'REQUESTED', label: 'Refund requests', labelKr: '환불 요청' },
  { value: 'COMPLETED', label: 'Refunded', labelKr: '환불 완료' },
  { value: 'REJECTED', label: 'Rejected', labelKr: '환불 거절' },
  { value: 'CANCELED', label: 'Canceled', labelKr: '취소' },
];

const AdminRefundsFilter = ({ currentFilter, onFilterChange }) => {
  const t = useT();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className='flex items-center p-1 rounded-[20px] bg-grayscale-gray02/50 h-[42px] w-full'>
        {REFUND_FILTERS.map(({ value, label, labelKr }) => {
          const isSelected = currentFilter === value;
          return (
            <button
              key={value}
              type='button'
              onClick={() => onFilterChange(value)}
              className={`flex-1 min-w-0 whitespace-nowrap px-1 py-2 typo-b12Strong transition-colors ${
                isSelected
                  ? 'bg-grayscale-gray00 text-text-primary rounded-[15px] shadow-3'
                  : 'bg-transparent text-text-secondary'
              }`}
            >
              {t(label, labelKr)}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className='flex items-center gap-2 flex-wrap'>
      {REFUND_FILTERS.map(({ value, label, labelKr }) => (
        <Chip
          key={value}
          type='fill'
          state={currentFilter === value ? 'selected' : 'default'}
          hideIcon={true}
          onClick={() => onFilterChange(value)}
          borderclass='ring-0'
        >
          {t(label, labelKr)}
        </Chip>
      ))}
    </div>
  );
};

export default AdminRefundsFilter;
